<template>
  <div class="laypage_main laypageskin_default">
    <p v-if="total" class="total-num">共{{ total }}条</p>
    <a href="javascript:;"
       class="laypage_prev"
       v-if="cur > 1 && prev&&pages>groups"
       @click.prevent="changePage(cur - 1)">{{prev}}</a>
    <a href="javascript:;"
       class="laypage_first"
       @click.prevent="changePage(1)"
       v-if="first&&pages>groups && pagesNumber[0] > 1">{{first}}</a>
    <a href="javascript:;"
       v-for="(page, index) in pagesNumber"
       :key="index"
       :style="[page === cur ? {color: '#FBFBFB', backgroundColor: skin, borderColor: skin} : '']"
       @click.prevent="changePage(page)">{{ page }}</a>
    <a href="javascript:;"
       class="laypage_last"
       @click.prevent="changePage(pages)"
       v-if="last&&pages>groups && pagesNumber[0] <= pages - groups">{{last}}</a>
    <a href="javascript:;"
       class="laypage_next"
       @click.prevent="changePage(cur + 1)"
       v-if="cur < pages && next&&pages>groups">{{next}}</a>
    <span class="laypage_total"
          v-if="skip&&pages>groups">
      <label>第</label>
      <input type="number"
             min="1"
             onkeyup="this.value=this.value.replace(/\D/, '');"
             class="laypage_skip"
             v-model="jumpPage">
      <label>页</label>
      <button type="button"
              class="laypage_btn"
              @click="jumpFunc">确定</button>
    </span>
  </div>
</template>

<script>
export default {
  name: 'laypage',
  data () {
    return {
      cur: 1,
      jumpPage: ''
    }
  },
  props: {
    total: {
      type: Number,
      default: 0
    },
    pages: {
      required: true,
      type: Number,
      default: 5
    },
    groups: {
      type: Number,
      default: 5
    },
    skin: {
      type: String,
      default: '#FFCB05'
    },
    first: {
      type: [String, Number, Boolean],
      default: '首页'
    },
    last: {
      type: [String, Number, Boolean],
      default: '>>'
    },
    prev: {
      type: [String, Boolean],
      default: '上一页'
    },
    next: {
      type: [String, Boolean],
      default: '下一页'
    },
    skip: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    pages () {
      this.cur = 1;
      // window.scrollTo(0, 0)
    }
  },
  computed: {

    pagesNumber () {
      let from
      let to
      const diff = (this.groups - 1) / 2
      if (this.groups > this.pages) {
        throw new Error('groups can not greater than pages')
      }
      if (this.diff % 2 === 0) {
        from = this.cur - diff
        to = this.cur + diff
      } else {
        from = this.cur - Math.floor(diff)
        to = this.cur + Math.ceil(diff)
      }
      if (from < 1) {
        from = 1
        to = this.groups
      }
      if (to >= this.pages) {
        to = this.pages
        from = to - this.groups + 1
      }
      const pagesArr = []
      while (from <= to) {
        pagesArr.push(from)
        from++
      }
      return pagesArr
    }
  },
  methods: {
    changePage (page) {
      if (page > this.pages) return
      window.scrollTo(0, 0)
      this.cur = page
      this.$emit('jump', page)
    },
    jumpFunc () {
      if (!this.jumpPage) return
      this.changePage(parseInt(this.jumpPage, 10))
      this.jumpPage = ''
    }
  }
}
</script>

<style scoped>
.laypage_main a,
.laypage_main input,
.laypage_main span {
  height: 0.41rem;
  line-height: 0.41rem;
  text-align: center;
}

.laypage_main button,
.laypage_main input,
.laypageskin_default a {
  background: rgba(221, 221, 221, 0);
  border: 1px solid #dddddd;
  border-radius: 0.06rem;
}

.laypage_main {
  font-size: 0;
  clear: both;
  color: #666;
}

.laypage_main * {
  display: inline-block;
  vertical-align: center;
  font-size: 0.18rem;
}

.laypage_main a {
  text-decoration: none;
  color: #666;
}

.laypage_main a,
.laypage_main span {
  margin: 0 0.03rem 0.06rem;
  min-width: 0.41rem;
  height: 0.41rem;
  padding: 0 0.1rem;
}

.laypage_main input {
  width: 0.4rem;
  margin: 0 0.05rem;
  padding: 0 0.05rem;
}

.laypage_main button {
  height: 0.41rem;
  line-height: 0.28rem;
  margin-left: 0.05rem;
  padding: 0 0.1rem;
  color: #fff;
  border: none;
  width: 0.8rem;
  background: #ffcb05;
}

.laypage_last {
  text-align: center;
}

.total-num {
  margin-right: 10px;
  font-size: 0.18rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Paginate.vue